import {
  type GetFolderPermissionsQuery,
  useGetFolderPermissionsQuery,
} from '../gql/generated/GetFolderPermissions';

export type FolderPermission = keyof Omit<
  NonNullable<
    Extract<
      NonNullable<NonNullable<GetFolderPermissionsQuery['account']>['asset']>,
      { __typename?: 'FolderAsset' }
    >['permissions']
  >,
  '__typename'
>;

type Args = {
  check: FolderPermission;
  folderId: string | undefined;
  isInitiallyPermitted?: boolean;
  skip?: boolean;
};

export function useFolderPermissions({
  check,
  folderId,
  isInitiallyPermitted = false,
  skip = false,
}: Args) {
  const { data } = useGetFolderPermissionsQuery({
    skip: !folderId || skip,
    variables: {
      folderId: folderId ?? '',
    },
  });

  const asset = data?.account?.asset;

  if (!asset || asset.__typename !== 'FolderAsset' || !asset.permissions)
    return false;

  if (typeof asset.permissions[check] === 'undefined')
    return isInitiallyPermitted;

  return asset.permissions[check] === true;
}
